import React from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { HostPrimaryButton } from '../components/HostSettingsCard';
import { HostOnboardingShell } from '../components/host-onboarding/HostOnboardingShell';
import { useBackTarget } from '../hooks/useBackTarget';

const SUPPORT_COPY = {
  listing: {
    title: 'Where do I find this?',
    subtitle: 'Airbnb listing URL',
    steps: [
      'Open the Airbnb listing you want to connect.',
      'Copy the full page URL from your browser address bar.',
      'Paste that link back into Allure.',
    ],
  },
  calendar: {
    title: 'Where do I find this?',
    subtitle: 'Calendar (iCal) link',
    steps: [
      "Open your listing's calendar on Airbnb.",
      'Tap Availability, then scroll down.',
      'Tap Connect calendar and copy the iCal link, then paste it into Allure.',
    ],
  },
};

export default function HostVerifyDetailsPage() {
  const navigate = useNavigate();
  const goBack = useBackTarget();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const topic = params.get('topic') === 'calendar' ? 'calendar' : 'listing';
  const content = SUPPORT_COPY[topic];

  return (
    <HostOnboardingShell
      onBack={goBack}
      pageTestId="host-verify-details-page"
      backTestId="host-verify-details-back-button"
      logoTestId="host-verify-details-logo"
      scrollable
      footer={<HostPrimaryButton onClick={goBack} dataTestId="host-verify-details-got-it-button">Got it</HostPrimaryButton>}
    >
      <h1 data-testid="host-verify-details-title" style={{ fontFamily: "'Inria Serif', serif", fontSize: 24, fontWeight: 700, color: 'var(--text)', textAlign: 'center', margin: '16px 0 0', lineHeight: 1.05 }}>
        {content.title}
      </h1>
      <p data-testid="host-verify-details-subtitle" style={{ fontFamily: "'Inria Serif', serif", fontSize: 18, fontWeight: 700, color: 'var(--accent-purple)', textAlign: 'center', margin: '10px 0 0', lineHeight: 1.1 }}>
        {content.subtitle}
      </p>

      <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 14, marginTop: 24 }}>
        {content.steps.map((step, index) => (
          <div key={`${topic}-${index}`} className="premium-card" data-testid={`host-verify-details-step-${index + 1}`} style={{ width: '100%', padding: '18px 16px', display: 'flex', gap: 12, alignItems: 'flex-start' }}>
            <span data-testid={`host-verify-details-step-${index + 1}-number`} style={{ fontFamily: "'Inria Serif', serif", fontSize: 24, fontWeight: 700, color: 'var(--text)', lineHeight: 1, minWidth: 22 }}>
              {index + 1}.
            </span>
            <p data-testid={`host-verify-details-step-${index + 1}-text`} style={{ fontFamily: "'Inria Serif', serif", fontSize: 18, fontWeight: 700, color: 'var(--text)', margin: 0, lineHeight: 1.15, textAlign: 'left' }}>
              {step}
            </p>
          </div>
        ))}
      </div>
    </HostOnboardingShell>
  );
}
